import React from "react";

export const TabletIcon = (): JSX.Element => {
    return (
        <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.25 0.75H3.25C1.86929 0.75 0.75 1.86929 0.75 3.25V18.25C0.75 19.6307 1.86929 20.75 3.25 20.75H14.25C15.6307 20.75 16.75 19.6307 16.75 18.25V3.25C16.75 1.86929 15.6307 0.75 14.25 0.75Z"
                stroke="#006E80"
                strokeWidth="1.5"
            />
            <path
                d="M8.74981 18.9498C9.41255 18.9498 9.94981 18.4125 9.94981 17.7498C9.94981 17.0871 9.41255 16.5498 8.74981 16.5498C8.08706 16.5498 7.5498 17.0871 7.5498 17.7498C7.5498 18.4125 8.08706 18.9498 8.74981 18.9498Z"
                fill="#006E80"
            />
        </svg>
    );
};
